export default {
    book: 'Varaa {product}',
    age_limit: 'Vain yli {age}-vuotiaille',
    change_plan: 'Vaihda suunnitelmaa',
    upgrade_product: 'Päivitä tuote',
    upgrade: 'Päivitä',
    cancel_upgrade: 'Peruuta päivitys',
    choose_product: 'Valitse {product}',
    days: '{count} päivä | {count} päivää',
    login_register: 'Kirjaudu/Rekisteröidy',
    current: 'Nykyinen',
    keyless_benefits: {
        label: 'Suoraan autolle {0}',
        highlight: 'vuokrauspalvelu™',
        list: {
            cant_lose_the_key: 'Täysi vakuutus',
            zero_excess: 'Ei omavastuuta',
            phone_as_a_key: 'Puhelin avaimena',
            straight_to_car: 'Ei odottelua',
            no_queues: 'Ei jonoja',
            online_id_check: 'Verkossa tehtävä henkilöllisyystarkistus',
            self_checkout: 'Itsepalvelu',
        },
    },
};
